import React, { Component } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { truncate } from 'lodash'
import Icon from '../../Shared/Icon'

const RECORD_LIMIT = process.env.REACT_APP_RECORD_LIMIT

export default class PlanSelect extends Component {
  handleClick = value => {
    const {
      input: { onChange },
    } = this.props

    onChange(value)

    return value
  }

  render() {
    const {
      input: { value },
      meta: { error, touched },
      hideFreeTier,
      annual,
      downgrade,
      appsOver,
    } = this.props

    let price
    let priceBusiness

    if (annual) {
      price = '$39/mo'
      priceBusiness = '$149/mo'
    } else {
      price = '$50/mo'
      priceBusiness = '$200/mo'
    }

    return (
      <>
        <div
          className={classNames('team-settings-plan-select', {
            error: error && touched,
          })}
        >
          {!hideFreeTier && (
            <PlanType
              initial={!value}
              name="Free"
              publish="Web app with Adalo Branding"
              data={
                downgrade && appsOver && appsOver.length > 0
                  ? appsOver
                  : `Up to ${RECORD_LIMIT} records of data per app`
              }
              collaborators="1 seat"
              selected={!value}
              onSelect={this.handleClick}
              value={null}
            />
          )}
          <PlanType
            initial={!value}
            name="Pro"
            price={price}
            web="Web App with Custom Domain"
            mobile="Publish to Apple & Google Play"
            data="5 GB of Data Storage"
            collaborators="1 seat included*"
            selected={value === 'pro'}
            onSelect={this.handleClick}
            value="pro"
          />
          <PlanType
            accountManager
            initial={!value}
            name="Business"
            price={priceBusiness}
            web="Web App with Custom Domain"
            mobile="Publish to Apple & Google Play"
            data="20 GB of Data Storage"
            collaborators="5 seats included*"
            selected={value === 'business'}
            onSelect={this.handleClick}
            value="business"
          />
        </div>
        <p className="plan-select-additional-info">
          *$20/month per additional seat.
        </p>
      </>
    )
  }
}

class PlanType extends Component {
  handleClick = e => {
    e.preventDefault()
    const { onSelect, value } = this.props

    onSelect(value)
  }

  renderItem = (icon, label) => (
    <div className="team-settings-plan-row">
      <Icon type={icon} />
      <p>{label}</p>
    </div>
  )

  renderWarning = data => {
    return (
      <div className={classNames('team-settings-warning')}>
        <div className="team-settings-warning-header">
          <div className="team-settings-warning-title">
            <Icon type="warning" color="orange" />
            <p>Up to {RECORD_LIMIT} records of data per app</p>
          </div>
        </div>
        <div className="team-settings-warning-body">
          {data.length > 1 ? (
            <p>
              You have apps that are at or over the 200 record limit for the
              Free plan. Users won't be able to add new records to:
            </p>
          ) : (
            <p>
              You have an app that is at or over the 200 record limit for the
              Free plan. Users won't be able to add new records to:
            </p>
          )}
          {this.renderAppsOverLimit(data)}
        </div>
      </div>
    )
  }

  renderAppsOverLimit = data => {
    let appsOver = data

    const appsOverMore = appsOver.length - 10
    const isOverTen = appsOver.length > 10
    let andMore

    if (isOverTen) {
      appsOver = appsOver.slice(0, 10)

      andMore = (
        <li key="more">
          <div className="team-settings-warning-list-item">
            <p className="team-settings-warning-list-more">
              And {appsOverMore} more
            </p>
          </div>
        </li>
      )
    }

    const listItems = appsOver.map(app => (
      <li key={app.appId}>
        <div className="team-settings-warning-list-item">
          <Link to={`/apps/${app.appId}/screens`}>
            <p>{truncate(app.appName, { length: 35 })}</p>
            <Icon type="open-in-new" small />
          </Link>
          <p className="team-settings-warning-list-count">
            ({app.metrics} records)
          </p>
        </div>
      </li>
    ))

    return (
      <ul className="team-settings-warning-list">
        {listItems}
        {isOverTen && andMore}
      </ul>
    )
  }

  render() {
    const {
      name,
      subtitle,
      price,
      selected,
      initial,
      publish,
      mobile,
      web,
      data,
      collaborators,
      accountManager,
    } = this.props

    return (
      <div
        className={classNames(
          'team-settings-plan-item',
          selected && 'team-settings-plan-selected',
          initial && 'team-settings-plan-initial'
        )}
        onClick={this.handleClick}
      >
        <div className="team-settings-plan-checkmark">
          <Icon type="done" />
        </div>

        <div className="team-settings-plan-header">
          <div className="team-settings-plan-title">
            <h3>{name}</h3>
            <div className="team-settings-plan-price">
              {price && ` • ${price}`}
            </div>
          </div>
          <p className="secondary">{subtitle}</p>
        </div>
        <div className="team-settings-plan-body">
          {publish && this.renderItem('phonelink', publish)}
          {web && this.renderItem('computer', web)}
          {mobile && this.renderItem('smartphone', mobile)}
          {data && typeof data === 'string' && this.renderItem('data', data)}
          {data && Array.isArray(data) && this.renderWarning(data)}
          {collaborators &&
            this.renderItem(
              collaborators.match(/^No/) ? 'user' : 'people',
              collaborators
            )}
          {accountManager &&
            this.renderItem('contact-email', 'Dedicated Adalo Account Manager')}
        </div>
      </div>
    )
  }
}
